// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { CreditMemo } from './credit-memo';
import { CreditMemoTypeEnum } from './enums';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class CreditMemoType extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Enum key */
  id!: CreditMemoTypeEnum;
  /** String(50) */
  name!: string;
  /** Inv FK creditMemoTypeId */
  creditMemos!: CreditMemo[];
}

